<template>
    <div v-if="hasAuth('Uets')">
        <list-container :header="translate('uetsInbox.uetsInboxList')" v-show="!$route.params.id">
            <template v-slot:commands>
                <div style="min-width: 350px;" class="accountDiv">
                    <div v-if="uetsInfo" style="min-width: 200px;">
                        <p v-if="uetsInfo.uetsDetails != null" class="m-0 p-0 font-italic text-muted">{{ translate('uetsInbox.refreshText: ' + uetsInfo.uetsDetails.RequestRate)}} ( {{ translate('uetsInbox.lastRefreshText') + (formattedRefreshDate) }} )</p>
                    </div>
                    <select-input v-if="providers" :items="providers" style="width: 150px;" v-model="selectedProvider"
                        @change="selectedProviderChanged">
                        <span v-if="selectedProvider" :key="selectedProvider.Id">
                            {{ selectedProvider.Name }}
                        </span>
                        <template v-slot:item="{ item }">
                            {{ item.Name }}
                        </template>
                    </select-input>
                </div>
            </template>
            <div v-if="noProviderFound" class="text-center pt-3 pb-2 font-italic text-muted">
                {{translate('uetsInbox.uetsProviderNotFound')}}
            </div>
            <list v-else-if="selectedProvider" ref="uetsList" @onload="$emit('onload')" :columns="columns" url="/uetsbox/get"
                modelName="Uets" :hideDeleteCommand="true" :filter="{ ProviderId: selectedProvider.Id }"
                :predicate="predicate">
            </list>
        </list-container>
        <router-view v-if="$route.params.id" />
    </div>
    <div v-else class="alert alert-danger">
        {{translate('errors.notAuthorizedForTheProcess')}}
    </div>
</template>

<script>
import list from '../components/List.vue'
import listContainer from '../components/ListContainer.vue'
import selectInput from "../components/SelectInput.vue";
import Vue from 'vue';
import axios from 'axios';
export default {
    computed:{
        formattedRefreshDate(){
            const dateObject = new Date(this.uetsInfo.uetsDetails.LastSync);
            const lang = localStorage.getItem('language')
            var returnData = ""
            if(dateObject.getDate() == new Date().getDate() && dateObject.getMonth() == new Date().getMonth()){
                lang == 'en' ? returnData = 'Today ' + dateObject.toLocaleString().split(' ')[1] : returnData = 'Bugün ' + dateObject.toLocaleString().split(' ')[1]
            }
            else
                returnData = dateObject.toLocaleString()
            return returnData
        }
    },
    created() {
        this.getUetsProviders()
            .then(x => {
                this.providers = x.Result
                var filteredProviders = this.providers.filter(x => x.IsActive == true);
                this.providers = filteredProviders
                var hasLocalProvider = JSON.parse(localStorage.getItem('UetsProvider'))
                if (this.providers && this.providers.length > 0) {
                    if (hasLocalProvider) {
                        this.selectedProvider = hasLocalProvider
                    }
                    else if (this.$route.params.provider) {
                        this.selectedProvider = this.providers.filter(x => x.Id == this.$route.params.provider)[0];
                    } else {
                        this.selectedProvider = this.providers[0];
                    }
                }else if(this.providers.length == 0){
                    this.noProviderFound = true
                }
                this.getUetsInfo()
            })
        
    },
    data() {
        return {
            user: null,
            filterForm: {},
            predicate: "",
            columns: [
                {
                    Key: "From",
                    Title: this.translate('remPreview.sender'),
                    SortField: "From",
                },
                {
                    Key: "Subject",
                    Title: this.translate('draftEyp.subject'),
                },
                {
                    Key: "SentDate",
                    Title: this.translate('draftEyp.date'),
                    SortField: "SentDate",
                    Content(i) {
                        return Vue.filter('datetime')(i.SentDate);
                    }
                },
            ],
            providers: [],
            selectedProvider: null,
            loading: false,
            uetsInfo: null,
            noProviderFound: false,
        }
    },
    components: {
        list,
        listContainer,
        selectInput,
    },
    methods: {
        selectedProviderChanged(value) {
            this.selectedProvider = value;
            localStorage.setItem('UetsProvider', JSON.stringify(this.selectedProvider))
            setTimeout(() => {
                this.$refs.uetsList.getData()
                this.getUetsInfo()
            }, 100);
        },
        async getUetsInfo() {
            this.loading = true
            await axios.get('/UetsProvider/get/' + this.selectedProvider.Id).then(x => {
                this.uetsInfo = x.data
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        checkInput(value, event) {
            // Check for invalid characters
            if (/[<>]/.test(event.target.value)) {
                alert(this.translate('errors.invalidSymbols'))
                const editedText = ""
                this.$set(this.filterForm, value, editedText)
            } else {
                this.$set(this.filterForm, value, event.target.value)
            }
        },
        applyFilter() {
            var parts = [];

            if (this.filterForm.Number)
                parts.push(`TrackingNo.Number == ${this.filterForm.Number}`);

            if (this.filterForm.Title)
                parts.push(`Title.Contains("${this.filterForm.Title}")`);


            this.predicate = parts.join(" && ");
            console.log(this.predicate);

            this.$refs.jobList.predicate = this.predicate;
            this.$refs.jobList.getData();
        }
    }
}
</script>

<style scoped>
.accountDiv {
    display: flex !important;
    flex-direction: row !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 10px;
}
</style>